import { useEffect, useMemo } from "react";
import {
  normalizeTeacherAccessibility,
  resolveTeacherThemeAttribute,
  teacherTextSizeToPx,
} from "../utils/teacherAccessibility";

const DEFAULT_ACCESSIBILITY = normalizeTeacherAccessibility(null);

export function useTeacherDisplayPreferences(accessibility) {
  const normalized = useMemo(
    () => normalizeTeacherAccessibility(accessibility),
    [accessibility],
  );

  const theme = useMemo(
    () => resolveTeacherThemeAttribute(normalized),
    [normalized],
  );

  useEffect(() => {
    const px = teacherTextSizeToPx(normalized.textSize);
    const root = document.documentElement;
    root.style.setProperty("--font-size", `${px}px`);
    root.style.fontSize = `${px}px`;
    root.style.colorScheme = "light";
    root.classList.remove("dark");
    return () => {
      root.style.colorScheme = "light";
      root.classList.remove("dark");
      root.style.setProperty("--font-size", "16px");
      root.style.fontSize = "16px";
    };
  }, [normalized.textSize]);

  return { theme, accessibility: normalized };
}

export { DEFAULT_ACCESSIBILITY };
